import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal modal-md fade",
  id: "modal-are-you-shure",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-footer" }
const _hoisted_5 = {
  class: "btn modal-footer_btn-cancel btn-outline-primary",
  type: "button",
  "data-bs-dismiss": "modal",
  style: "margin-right: auto"
}
const _hoisted_6 = {
  class: "btn modal-footer_btn-process btn-primary",
  type: "button",
  "data-bs-dismiss": "modal",
  "data-bs-target": "#modal-download-instruction",
  "data-bs-toggle": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"modal-header\"><h1 class=\"modal-title fs-5 color--danger\" id=\"messageModalAreYouShure\">Atenção!</h1><button class=\"btn-close\" type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Fechar\"></button></div><div class=\"modal-body pt-1\"><div class=\"text text-start fs-6\">Ao utilizar nosso emissor, <strong>não</strong> será possível utilizar sua própria chave posteriormente. Tem certeza de que deseja utilizar o emissor?</div></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "lock"
            }),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "Utilizar meu CSR", -1))
          ]),
          _createElementVNode("button", _hoisted_6, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "download"
            }),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Baixar emissor", -1))
          ])
        ])
      ])
    ])
  ]))
}